<div class="progress-bg">
  <div class="progress-score" [ngStyle]="{ width: getWidth(score), 'background-color': getProgressColor(score) }"></div>
</div>
